import { render, staticRenderFns } from "./CreateNewProjectModal.vue?vue&type=template&id=b877a42a"
import script from "./CreateNewProjectModal.vue?vue&type=script&lang=js"
export * from "./CreateNewProjectModal.vue?vue&type=script&lang=js"
import style0 from "./CreateNewProjectModal.vue?vue&type=style&index=0&id=b877a42a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports